// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Qt-z","tooltipWrapper":"Rt-z","icon":"St-z","tooltip":"Tt-z","content":"Ut-z"};